import { useState, useEffect } from "react";
import { NotificationManager } from "react-notifications";
import instance from "../api/interceptor";

function useAutoComplete(url = "", key = "Description") {
  const [value, setValue] = useState({});
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState({});
  const [options, setOptions] = useState([]);

  useEffect(() => {
    getOptions();
  }, []);

  const setInitial = (item) => {
    setValue({ ...item });
  };

  const getOptions = () => {
    if (url) {
      instance
        .get(url)
        .then((res) => {
          setOptions(res.data);
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
            NotificationManager.error(err.response.data.Message, "", 3000);
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
          setOptions([]);
        });
    }
  };

  const onGetSearchChange = (path, notAddress = true) => {
    if (path) {
      instance
        .get(path)
        .then((res) => {
          notAddress ? setOptions(res.data) : setOptions(res.data[0].Addresses);
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
            NotificationManager.error(err.response.data.Message, "", 3000);
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
          setOptions([]);
        });
    }
  };

  const onChange = (event, newValue) => {
    console.log("onchangev", newValue);
    setValue(newValue ?? { key: "" });

  };

  return {
    value,
    error,
    errorMsg,
    options,
    setValue,
    onChange,
    setError,
    setErrorMsg,
    setOptions,
    setInitial,
    onGetSearchChange
  };
}

export default useAutoComplete;
